// 回頭客分析頁的純資料整理。刻意不 import antd/axios/echarts，測試才跑得動
// (慣例同 FeedbackSummaryCard/feedbackItem.js)。

export const CHANNELS = ["OTA", "DIRECT", "OTHER"];
export const CHANNEL_LABEL = { OTA: "OTA", DIRECT: "直訂", OTHER: "其他" };
// OTA 用警示色 (這份報表要盯的就是它)，直訂用正向色，其他用中性灰
export const CHANNEL_COLOR = { OTA: "#d46b08", DIRECT: "#08979c", OTHER: "#8f8f8f" };
const PARTIAL_OPACITY = 0.45;

export function formatShare(v) {
  return v == null ? "—" : `${(v * 100).toFixed(1)}%`;
}

export function money(v) {
  return `NT$${Math.round(v || 0).toLocaleString()}`;
}

const signed = (n, digits = 0) => `${n > 0 ? "+" : ""}${n.toFixed(digits)}`;
// 次數與金額加千分位 (+287,086)；百分比另用 signed 維持一位小數
const signedCount = (n, unit = "") => `${n > 0 ? "+" : "-"}${unit}${Math.round(Math.abs(n)).toLocaleString("en-US")}`;

/**
 * 本期對前期的增減。lowerIsBetter 決定紅綠：佣金與直訂流失越低越好，方向要反過來，
 * 否則「佣金暴增」會被標成綠色。kind = 'share' 時以百分點表示，'money' 時加 NT$。
 */
export function kpiDelta(cur, prev, lowerIsBetter, kind = "count") {
  if (cur == null || !prev) return { text: "前期無資料", tone: "flat" };
  const diff = cur - prev;
  if (diff === 0) return { text: "持平", tone: "flat" };
  const improved = lowerIsBetter ? diff < 0 : diff > 0;
  const text = kind === "share"
    ? `${signed(diff * 100, 1)} 個百分點`
    : `${signedCount(diff, kind === "money" ? "NT$" : "")} (${signed((diff / prev) * 100, 1)}%)`;
  return { text, tone: improved ? "good" : "bad" };
}

const label = (s) => (s.partial ? `${s.period} (未完整)` : s.period);
const point = (value, partial) => (partial ? { value, itemStyle: { opacity: PARTIAL_OPACITY } } : { value });

export function visitsOption(series) {
  return {
    tooltip: { trigger: "axis" },
    legend: { bottom: 0 },
    grid: { left: 48, right: 56, top: 40, bottom: 56 },
    xAxis: { type: "category", data: series.map(label) },
    yAxis: [
      { type: "value", name: "回訪次數", minInterval: 1 },
      { type: "value", name: "OTA 佔比", min: 0, max: 100, axisLabel: { formatter: "{value}%" } },
    ],
    series: [
      ...CHANNELS.map((ch) => ({
        name: CHANNEL_LABEL[ch],
        type: "bar",
        stack: "visits",
        itemStyle: { color: CHANNEL_COLOR[ch] },
        data: series.map((s) => point(s[ch.toLowerCase()], s.partial)),
      })),
      {
        name: "OTA 佔比",
        type: "line",
        yAxisIndex: 1,
        itemStyle: { color: "#262626" },
        tooltip: { valueFormatter: (v) => (v == null ? "—" : `${v}%`) },
        data: series.map((s) => (s.ota_share == null ? null : Math.round(s.ota_share * 1000) / 10)),
      },
    ],
  };
}

export function commissionOption(series) {
  return {
    tooltip: { trigger: "axis", valueFormatter: money },
    grid: { left: 72, right: 24, top: 40, bottom: 32 },
    xAxis: { type: "category", data: series.map(label) },
    yAxis: { type: "value", name: "佣金", axisLabel: { formatter: (v) => (v >= 1000 ? `${Math.round(v / 1000)}k` : `${v}`) } },
    series: [{
      name: "回訪佣金",
      type: "bar",
      itemStyle: { color: CHANNEL_COLOR.OTA },
      data: series.map((s) => point(s.commission, s.partial)),
    }],
  };
}

/** 3×3 流向轉成表格列：每列是「上次通路」，三個欄位是「這次通路」 */
export function flowRows(flows) {
  return CHANNELS.map((prev) => {
    const row = { prev };
    CHANNELS.forEach((cur) => {
      row[cur] = flows.find((f) => f.prev === prev && f.cur === cur) || { visits: 0, nights: 0, amount: 0, commission: 0 };
    });
    return row;
  });
}
